/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 36.5 36.5',
    data: '<path pid="0" _fill="#6ebe44" d="M8.81 10.58h20v1.33h-20zM8.81 15.25h20v1.33h-20zM8.81 19.92h20v1.33h-20zM8.81 24.58h20v1.33h-20z"/><path pid="1" _fill="none" _stroke="#6ebe44" stroke-width="1.5" stroke-miterlimit="10" d="M41 40.19h35v35H41z"/><g _fill="#6ebe44"><path pid="2" d="M68.5 53.46h-20v-5.77h20v5.77zm-18.75-1.25h17.5v-3.27h-17.5v3.27zM68.5 60.58h-20v-5.77h20v5.77zm-18.75-1.25h17.5v-3.27h-17.5v3.27zM68.5 67.69h-20v-5.77h20v5.77zm-18.75-1.25h17.5v-3.27h-17.5v3.27z"/></g>'
}
